import React, { Component } from 'react';

import { isMobileOnly } from 'react-device-detect';
import PerfectScrollbar from 'react-perfect-scrollbar';


import AppMenu from '../AppMenu';


import './styles.scss';

/**
 * Sidenav
 */
const SideNav = (props) => {
    return <div className="sidebar-content">
        <div id="sidebar-menu">
            <AppMenu/>
        </div>
    </div>;
};

class LeftSidebar extends Component {
    menuNodeRef;

    constructor(props) {
        super(props);
        this.handleOtherClick = this.handleOtherClick.bind(this);
        this.state = {};
    }

    /**
     * Bind event
     */
    componentDidMount = () => {
        document.addEventListener('mousedown', this.handleOtherClick, false);
    };

    /**
     * Bind event
     */
    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleOtherClick, false);
    };

    /**
     * Handle the click anywhere in doc
     */
    handleOtherClick = (e) => {
        if (this.menuNodeRef.contains(e.target)) return;
        // else hide the menubar
        if (document.body && isMobileOnly) {
            document.body.classList.remove('sidebar-enable');
        }
    };


    render() {
        const isCondensed = this.props.isCondensed || false;

        return (
            <React.Fragment>
                <div className='' ref={node => this.menuNodeRef = node}>
                    {!isCondensed && <PerfectScrollbar><SideNav/></PerfectScrollbar>}
                    {isCondensed && <SideNav/>}
                </div>
            </React.Fragment>
        );
    }
}

export default LeftSidebar;